import { INVOICE_PROCESS_TYPES } from 'appconstants';

export default value => {
  switch (value) {
    case 'PARTIAL':
      return INVOICE_PROCESS_TYPES.PARTIAL;
    case 'REGULAR':
      return INVOICE_PROCESS_TYPES.REGULAR;
    default:
      return INVOICE_PROCESS_TYPES.REGULAR;
  }
};
